<template>
  <!--
    Augenschalter im Passwortfeld (dokumente#43, OD-AT-050, FE-028).

    Vorher :append-icon mit @click:append - Vuetify benennt das Symbol dann
    "Passwort appended action", in beiden Zustaenden gleich. Jetzt ein
    Knopf mit Namen nach Zustand und aria-pressed.
  -->
  <v-btn
    icon
    small
    :aria-label="sichtbar ? 'Passwort verbergen' : 'Passwort anzeigen'"
    :aria-pressed="sichtbar ? 'true' : 'false'"
    data-cy="passwortAuge"
    @click="$emit('umschalten')"
  >
    <v-icon>{{ sichtbar ? "mdi-eye" : "mdi-eye-off" }}</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: "PasswortAuge",
  props: {
    sichtbar: { type: Boolean, default: false },
  },
};
</script>
